import React, { useEffect } from 'react';
import { Row } from 'react-bootstrap';
// import { Link } from 'react-router-dom';

import PageWrapper from '../components/PageWrapper';
import Title from './components/Title';
import Highlights from './components/Highlights';
import MessageFromPresident from './components/MessageFromPresident';
import MessageFromChairman from './components/MessageFromChairman';
import WhoWeAre from './components/WhoWeAre';
import OurMembers from './components/OurMembers';
import BoardOfDirectors from './components/BoardOfDirectors';
import WelcomingAMember from './components/WelcomingAMember';
import WhoWeAreValue from './components/WhoWeAreValue';
import DownloadTheFullReport from './components/DownloadTheFullReport';
import ScrollToTop from '../components/ScrollToTop';

import collaboration1 from '../../assets/images/collaboration1.png';
import innovation1 from '../../assets/images/innovation1.png';
import credible1 from '../../assets/images/credible1.png';

const HomePage = (props) => {
  const { height, width, MAX_WIDTH, isMobile } = props;

  useEffect(() => {
    window.scrollTo(0,document.body.scrollHeight);
    window.scrollTo(0,0);
  }, []);

  return (
    <PageWrapper height={height} maxWidth={MAX_WIDTH} fadeStyle showHeaderLogo foo transparentHeader isMobile={isMobile}>
      <Row>
        <Title />
      </Row>
      <div className="backgroundRectangle" style={{
        position: 'absolute',
        height: 1300,
        width,
        zIndex: -1
      }} />
      <Row style={{ marginTop: 120 }}>
        <Highlights width={width} isMobile={isMobile} />
      </Row>
      <div className="backgroundArrow" style={{
        position: 'absolute',
        height: 2600,
        width,
        zIndex: -1
      }} />
      <Row style={{ marginTop: 120 }}>
        <MessageFromPresident width={width} isMobile={isMobile}/>
      </Row>
      <Row style={{ marginTop: 120 }}>
        <MessageFromChairman width={width} isMobile={isMobile}/>
      </Row>
      <div className="backgroundRectangle" style={{
        position: 'absolute',
        height: 1200,
        width,
        zIndex: -1
      }} />
      <Row style={{ marginTop: 120 }}>
        <WhoWeAre isMobile={isMobile}/>
      </Row>
      <Row style={{ marginTop: isMobile ? 0 : 120 }}>
        <OurMembers />
      </Row>
      <div className="backgroundArrow" style={{
        position: 'absolute',
        height: 2600,
        width: width,
        zIndex: -1
      }} />
      <Row style={{ marginTop: 120 }}>
        <BoardOfDirectors width={width} isMobile={isMobile}/>
      </Row>
      <ScrollToTop height={height} width={width} maxWidth={MAX_WIDTH}/>
      <Row style={{ marginTop: 40 }}>
        <WelcomingAMember />
      </Row>
      <Row style={{ marginTop: 90 }}>
        <WhoWeAreValue width={width} text={innovationText} title="INNOVATION" imgSrc={innovation1} imgAlt="" id="innovation" href="/innovation" />
      </Row>
      <Row style={{ marginTop: 90 }}>
        <WhoWeAreValue width={width} text={collaborationText} title="COLLABORATION" imgSrc={collaboration1} imgAlt="" id="collaboration" href="/collaboration" />
      </Row>
      <Row style={{ marginTop: 90 }}>
        <WhoWeAreValue width={width} text={credibleText} title="CREDIBLE" imgSrc={credible1} imgAlt="" id="credible" href="/credible" />
      </Row>
      <Row style={{ marginTop: 120 }}>
        <DownloadTheFullReport />
      </Row>
    </PageWrapper>
  )
}

export default HomePage;

const innovationText = "Industry standards are at the heart of everything we do. We use CSIO Standards to develop innovative solutions – CSIOnet, eDocs and eSlips, just to name a few.\n\nThose same standards – like eDocs – support even more innovative solutions, like the ones you’ll read about in this section of the report. It’s a never-ending cycle of benefits and efficiencies – one that allows us to bring more solutions to CSIO members, in shorter timeframes.\n\n2020 was an unusual year. But the challenges kept feeding the innovation, as we found new ways to connect and keep moving forward.";
const collaborationText = "Collaboration is in our DNA – we were founded on the need to work together to achieve more. 2020 will be remembered as the year when the ways we collaborated changed forever.\n\nDespite COVID-19 halting in-person meetings, we’re proud that we could still connect all of our stakeholders – brokers, insurers, vendors and associations.\n\nThanks to our members, we didn’t miss a step. We were able to continue collaborating and progressing towards industry innovation.";
const credibleText = "CSIO invests continuously in innovation and programs. Members know they can count on those same innovations and programs to keep them informed. They trust CSIO for the best information and solutions.\n\nThanks to that trust, members have embraced certification on data standards, eDocs and are now becoming Digital Members. This year, more than ever, they made the most of eLearning. Online, the conversations were humming, and we kept information moving with articles, press releases and social posts.\n\nAll of it adds up to trust and solid thought leadership."

